var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "add-item-to-basket-overlay" } }, [
    _c("div", { staticClass: "modal fade" }, [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _vm.basketItem
          ? _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title h5" }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.singleItemAdded"))
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "closeOverlay",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.closeIcon"
                        )
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm.manyMoreItems.items.length > 0
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center mb-4 font-weight-bold mt-3"
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Snaply5::Template.overlayBasketItemsText",
                                      { count: _vm.manyMoreItems.count }
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "choosen-colors" },
                                [
                                  _vm._l(_vm.manyMoreItems.items, function(
                                    item
                                  ) {
                                    return _c("div", [
                                      _c("div", [
                                        _c("img", {
                                          staticClass: "img-fluid",
                                          attrs: {
                                            src:
                                              item.data.images.all[0].urlPreview
                                          }
                                        })
                                      ])
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _vm.manyMoreItems.count > 4
                                    ? [_vm._m(1)]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      : [
                          _c("div", { staticClass: "row is-table-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-4",
                                staticStyle: { "min-height": "80px" }
                              },
                              [
                                _c("img", {
                                  staticClass: "img-fluid mx-auto",
                                  staticStyle: { "max-height": "140px" },
                                  attrs: {
                                    src: _vm.current.image.urlPreview,
                                    alt: _vm.current.image.names.alternate,
                                    title: _vm.current.image.names.alternate
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-8" },
                              [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.current.variation.data.texts.name1
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.countAdditionalBasketItems > 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.basketItemOverlayAdditionalCount",
                                              {
                                                count:
                                                  _vm.countAdditionalBasketItems
                                              }
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "small" }, [
                                  _c("strong", [
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(_vm.current.quantity) + " x "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.current.price)
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.current.variation.data.attributes,
                                  function(attribute) {
                                    return _c("p", { staticClass: "small" }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(attribute.attribute.names.name)
                                        )
                                      ]),
                                      _vm._v(":\n                          "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(attribute.value.names.name)
                                        )
                                      ])
                                    ])
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        ],
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "waiting-animation-infinite",
                                  rawName: "v-waiting-animation-infinite"
                                }
                              ],
                              staticClass: "btn btn-primary mr-2 pull-right",
                              staticStyle: { "min-width": "33%" },
                              attrs: { href: _vm.urls.basket, rel: "nofollow" }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-shopping-cart",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Snaply5::Template.singleItemBasketOverlay"
                                    )
                                  ) +
                                  "\n                      "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.crossitems.length > 0 && _vm.current.quantity > 0.1
                          ? [
                              _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "h3 my-4" }, [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Snaply5::Template.basketOverlayHeadlineCrossSeller"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.crossitems.length > 0 && _vm.current.quantity > 0.1
                      ? [
                          _c(
                            "carousel",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.crossitems.length > 0,
                                  expression: "crossitems.length > 0"
                                }
                              ],
                              attrs: {
                                "items-per-page": 3,
                                mini: this.crossitems.length < 3
                              }
                            },
                            [
                              _vm._l(_vm.crossitems, function(item) {
                                return _c(
                                  "template",
                                  { slot: "items" },
                                  [
                                    _c("category-item", {
                                      key: item.id,
                                      attrs: {
                                        "item-data": item.data,
                                        "decimal-count":
                                          _vm.$ceres.config.item.storeSpecial,
                                        "disable-carousel-on-mobile": false,
                                        "show-rating": true,
                                        "show-cart": true,
                                        "wish-is-active": false,
                                        "show-variation-image-possible": true,
                                        "show-attributes": true
                                      }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("extendOverlayButtons")
              ],
              2
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-muted ml-auto" }, [
      _c("span", { staticClass: "timer" }),
      _vm._v("s")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lot-more-colors" }, [
      _c("span", { staticClass: "dot" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }